import MapsContainer from "./MapsContainer.view"

export default MapsContainer
